import React from 'react';
import MegaOptionContainer from '../../../Componant/Forms/FormControl/MegaOption';

const MegaOption = () => {
  return (
    <div className='page-body'>
      <MegaOptionContainer />
    </div>
  );
};

export default MegaOption;
